exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-input[data-v-07d562c7] .ant-form-item-children {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.add-input[data-v-07d562c7] .ant-form-item-children .ant-input {\n  -webkit-box-flex: 1;\n  -webkit-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.add-input[data-v-07d562c7] .ant-form-item-children .anticon-delete {\n  width: 28px;\n}\n", ""]);

// exports
